import "./RegisterlLogin.css";
import { CardLoginAndRegister } from "../cards/CardLoginAndRegister";
import { FormLogin } from "../forms/FormLogin";
import { FormRegister } from "../forms/FormRegister";

export function RegisterLogin(props: { setShowRegisterLogin: React.Dispatch<React.SetStateAction<boolean>>, isShowFormLogin: boolean, setIsShowFormLogin: React.Dispatch<React.SetStateAction<boolean>> }) {
  const { setShowRegisterLogin, isShowFormLogin, setIsShowFormLogin } = props; //destructuring

  function handleSwitchForm() {
    setIsShowFormLogin(prev => !prev);
  }

  return (
    <>
      <div className="flex justify-start">
        <button
          className="text-white px-3 md:px-4 py-2 rounded-xl"
          style={{ backgroundColor: "#335C67", color: "white" }}
          type="button"
          onClick={() => setShowRegisterLogin(false)}
        >
          Accueil
        </button>
      </div>

      <section id="section-login" className="flex items-start gap-4 py-14">
        {
          isShowFormLogin ? <FormLogin /> : <FormRegister />
        }
        <CardLoginAndRegister handleSwitchForm={handleSwitchForm} isShowFormLogin={isShowFormLogin} setIsShowFormLogin={setIsShowFormLogin} />
      </section>
    </>
  )

}